import type { paths } from "@web-monorepo/api-types";

export type ParentReferralAccount =
  paths["/api/marketplace/parent/referral-code"]["get"]["responses"][200]["content"]["application/json"];
export type ParentReferralOffer = ParentReferralAccount["currentOffer"];
export type ParentReferralClaim = NonNullable<ParentReferralAccount["recipientClaim"]>;

export function getParentReferralOfferMetadata(terms: ParentReferralOffer | ParentReferralClaim | undefined) {
  if (!terms) return {};
  return {
    campaignId: terms.campaignId,
    campaignRevision: terms.campaignRevision,
    experimentName: terms.experimentName,
    experimentVariant: terms.experimentVariant,
    recipientRewardCount: terms.recipientRewardCount,
    inviterRewardCount: terms.inviterRewardCount,
  };
}

export function getParentReferralTransitionDelay(offer: ParentReferralOffer, receivedAt: number, now: number) {
  if (!offer.nextTransitionAt) return undefined;
  // Measure against the server clock, including elapsed time since this response arrived.
  const delay = Date.parse(offer.nextTransitionAt) - Date.parse(offer.serverTime) - (now - receivedAt);
  return Number.isFinite(delay) ? Math.max(0, delay) : undefined;
}
